import $http from '@/model/utils/http'

// 获取用户数据
const getUserList = (params) => $http.get('/org/User/getUserList', {
    params
  })
// 获取用户绑定设备列表
const getUserDeviceList = (params) => $http.get('/org/User/getUserBindEq', {
    params
  })

// 获取用户详情-基础信息
const getUserBaseInfo = (params) => $http.get('/org/User/getUserHealthBase', {
    params
  })
// 获取用户详情-健康指标
const getUserHealthInfo = (params) => $http.get('/org/User/getUserHeadlthDate', {
    params
  })
// 获取用户详情-分析报告
const getUserReport= (params) => $http.get('/org/user/getReport', {
  params
})

// 获取历史数据-血压
const getBloodPressure = (params) => $http.get('/org/user/getUserBloodPressure', {
    params
  })
// 获取历史数据-血氧
const getBloodOxygene = (params) => $http.get('/org/user/getUserBloodOxygene', {
    params
  })
// 获取历史数据-血糖
const getBloodSugar = (params) => $http.get('/org/user/getUserBloodSugar', {
    params
  })
// 获取历史数据-体温
const getTemperature = (params) => $http.get('/org/user/getUserTemperature', {
    params
  })
// 获取历史数据-心电
const getHeartRate = (params) => $http.get('/org/user/getUserHeartRate', {
    params
  })
// 获取历史数据-运动
const getSport = (params) => $http.get('/org/user/getUserSport', {
    params
  })
// 获取历史数据-体脂
const getBodyFat = (params) => $http.get('/org/user/getBodyfat', {
    params
  })

export default {
    getUserList,
    getUserDeviceList,
    getUserBaseInfo,
    getUserHealthInfo,
    getUserReport,
    getBloodPressure,
    getBloodOxygene,
    getBloodSugar,
    getTemperature,
    getHeartRate,
    getSport,
    getBodyFat    
}
